"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isObject = exports.verifyObject = exports.checkField = void 0;
exports.checkField = (e, attribute, isOptional = false, type = "string") => {
    const v = e[attribute];
    const isNotDefined = v === null || v === undefined;
    if (isOptional && isNotDefined) {
        return true;
    }
    if (isNotDefined) {
        return false;
    }
    if (typeof v === type) {
        return true;
    }
    return false;
};
exports.verifyObject = (e, structure, optional = false) => {
    if (!e && optional) {
        return true;
    }
    return structure
        .map((s) => {
        if (Array.isArray(s.type)) {
            return exports.verifyObject(e[s.name], s.type, s.optional);
        }
        else {
            return exports.checkField(e, s.name, s.optional, s.type);
        }
    })
        .reduce((a, b) => a && b);
};
exports.isObject = (objectToType, structure) => exports.verifyObject(objectToType, structure);
